'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MultiSelectDropdown, type MultiSelectOption, type MultiSelectGroup } from '@/components/ui/multi-select-dropdown';
import { useCountries } from '@/lib/hooks/useCountries';
interface CountrySelectProps {
  mode?: 'single' | 'multiple';
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string | null;
  showChips?: boolean;
  showSummaryInTrigger?: boolean;
  maxSummaryLength?: number;
  showBulkActions?: boolean;
  enableGrouping?: boolean;
  showSearch?: boolean;
  searchPlaceholder?: string;
}
export function CountrySelect(t0) {
  const $ = _c(52);
  const {
    mode: t1,
    value,
    onValueChange,
    placeholder: t2,
    disabled: t3,
    label: t4,
    showChips: t5,
    showSummaryInTrigger: t6,
    maxSummaryLength: t7,
    showBulkActions: t8,
    enableGrouping: t9,
    showSearch: t10,
    searchPlaceholder: t11
  } = t0;
  const mode = t1 === undefined ? "single" : t1;
  const placeholder = t2 === undefined ? "Select country..." : t2;
  const disabled = t3 === undefined ? false : t3;
  const label = t4 === undefined ? null : t4;
  const showChips = t5 === undefined ? true : t5;
  const showSummaryInTrigger = t6 === undefined ? false : t6;
  const maxSummaryLength = t7 === undefined ? 40 : t7;
  const showBulkActions = t8 === undefined ? true : t8;
  const enableGrouping = t9 === undefined ? false : t9;
  const showSearch = t10 === undefined ? true : t10;
  const searchPlaceholder = t11 === undefined ? "Search countries..." : t11;
  const {
    data: t12,
    isLoading
  } = useCountries();
  let t13;
  if ($[0] !== t12) {
    t13 = t12 === undefined ? [] : t12;
    $[0] = t12;
    $[1] = t13;
  } else {
    t13 = $[1];
  }
  const countries = t13;
  let t14;
  bb0: {
    if (!enableGrouping) {
      let t15;
      if ($[2] !== countries) {
        t15 = countries.map(_temp);
        $[2] = countries;
        $[3] = t15;
      } else {
        t15 = $[3];
      }
      const opts = t15;
      let t16;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = [];
        $[4] = t16;
      } else {
        t16 = $[4];
      }
      let t17;
      if ($[5] !== opts) {
        t17 = {
          options: opts,
          groups: t16 as MultiSelectGroup[]
        };
        $[5] = opts;
        $[6] = t17;
      } else {
        t17 = $[6];
      }
      t14 = t17;
      break bb0;
    }
    let t15;
    if ($[7] !== countries) {
      const regionMap = new Map();
      countries.forEach(c_0 => {
        const existing = regionMap.get(c_0.region);
        if (existing) {
          existing.push(c_0);
        } else {
          regionMap.set(c_0.region, [c_0]);
        }
      });
      const grps = [];
      const opts_0 = [];
      Array.from(regionMap.entries()).sort(_temp2).forEach(t16 => {
        const [region, regionCountries] = t16;
        grps.push({
          id: region,
          label: region
        });
        regionCountries.sort(_temp3).forEach(c_1 => {
          opts_0.push({
            id: c_1.alpha2,
            label: `${c_1.emoji} ${c_1.name}`,
            groupId: region
          });
        });
      });
      t15 = {
        options: opts_0,
        groups: grps
      };
      $[7] = countries;
      $[8] = t15;
    } else {
      t15 = $[8];
    }
    t14 = t15;
  }
  const {
    options,
    groups
  } = t14;
  if (isLoading) {
    let t15;
    if ($[9] !== label) {
      t15 = label && <label className="text-xs font-bold text-zinc-500 dark:text-zinc-500 uppercase tracking-widest block">{label}:</label>;
      $[9] = label;
      $[10] = t15;
    } else {
      t15 = $[10];
    }
    let t16;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <div className="w-full md:w-auto min-w-[240px] px-4 py-2.5 rounded-xl bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-800 text-sm font-medium text-zinc-400 dark:text-zinc-500">Loading countries...</div>;
      $[11] = t16;
    } else {
      t16 = $[11];
    }
    let t17;
    if ($[12] !== t15) {
      t17 = <div className="space-y-2">{t15}{t16}</div>;
      $[12] = t15;
      $[13] = t17;
    } else {
      t17 = $[13];
    }
    return t17;
  }
  if (mode === "multiple") {
    let t15;
    if ($[14] !== value) {
      t15 = Array.isArray(value) ? value : value ? [value] : [];
      $[14] = value;
      $[15] = t15;
    } else {
      t15 = $[15];
    }
    const selectedIds = t15;
    let t16;
    if ($[16] !== onValueChange) {
      t16 = ids => onValueChange?.(ids);
      $[16] = onValueChange;
      $[17] = t16;
    } else {
      t16 = $[17];
    }
    const t17 = countries.length > 50;
    let t18;
    if ($[18] !== disabled || $[19] !== groups || $[20] !== label || $[21] !== maxSummaryLength || $[22] !== options || $[23] !== placeholder || $[24] !== searchPlaceholder || $[25] !== selectedIds || $[26] !== showBulkActions || $[27] !== showChips || $[28] !== showSearch || $[29] !== showSummaryInTrigger || $[30] !== t16 || $[31] !== t17) {
      t18 = <MultiSelectDropdown label={label} placeholder={placeholder} options={options} selectedIds={selectedIds} onSelectionChange={t16} showChips={showChips} showSummaryInTrigger={showSummaryInTrigger} maxSummaryLength={maxSummaryLength} showBulkActions={showBulkActions} disabled={disabled} groups={groups} enableVirtualization={t17} showSearch={showSearch} searchPlaceholder={searchPlaceholder} />;
      $[18] = disabled;
      $[19] = groups;
      $[20] = label;
      $[21] = maxSummaryLength;
      $[22] = options;
      $[23] = placeholder;
      $[24] = searchPlaceholder;
      $[25] = selectedIds;
      $[26] = showBulkActions;
      $[27] = showChips;
      $[28] = showSearch;
      $[29] = showSummaryInTrigger;
      $[30] = t16;
      $[31] = t17;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    return t18;
  }
  const selectedValue = typeof value === "string" ? value : Array.isArray(value) ? value[0] : undefined;
  let t15;
  if ($[33] !== label) {
    t15 = label && <label className="text-xs font-bold text-zinc-500 dark:text-zinc-500 uppercase tracking-widest block">{label}:</label>;
    $[33] = label;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== onValueChange) {
    t16 = v => onValueChange?.(v);
    $[35] = onValueChange;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== placeholder) {
    t17 = <SelectTrigger className="w-full md:w-auto min-w-[240px] cursor-pointer"><SelectValue placeholder={placeholder} /></SelectTrigger>;
    $[37] = placeholder;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== countries) {
    t18 = countries.sort(_temp4).map(_temp5);
    $[39] = countries;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t18) {
    t19 = <SelectContent>{t18}</SelectContent>;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== disabled || $[44] !== selectedValue || $[45] !== t16 || $[46] !== t17 || $[47] !== t19) {
    t20 = <Select value={selectedValue} onValueChange={t16} disabled={disabled}>{t17}{t19}</Select>;
    $[43] = disabled;
    $[44] = selectedValue;
    $[45] = t16;
    $[46] = t17;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t15 || $[50] !== t20) {
    t21 = <div className="space-y-2">{t15}{t20}</div>;
    $[49] = t15;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  return t21;
}
function _temp5(country) {
  return <SelectItem key={country.name} value={country.alpha2} className="cursor-pointer">{country.emoji} {country.name}</SelectItem>;
}
function _temp4(a_1, b_1) {
  return a_1.name.localeCompare(b_1.name);
}
function _temp3(a_0, b_0) {
  return a_0.name.localeCompare(b_0.name);
}
function _temp2(t0, t1) {
  const [a] = t0;
  const [b] = t1;
  return a.localeCompare(b);
}
function _temp(c) {
  return {
    id: c.alpha2,
    label: `${c.emoji} ${c.name}`
  };
}